export default __webpack_public_path__ + "static/flowers-ea9f2e23aa8489b91ccf163c941997b9.png";